import React from "react";
import FloatingLogoAndButton from "../FloatingLogoAndButton/FloatingLogoAndButton";

const Regulaminy = () => {
  return (
    <div className="h-[100vh] bg-black">
      <FloatingLogoAndButton />
      <h3 className="text-white text-xl pt-32 px-8">
        Poniżej znajdą państwo regulaminy do naszych aktualnych promocji:
      </h3>
      <ul className="mt-4 px-8">
        <li>
          <a
            href="https://www.whitebull.com.pl/Promocja_Whitebull_50.pdf"
            target="_blank"
            className="text-white underline text-lg"
          >
            Gdańsk - Promocja zjedz w marcu odbierz 50% zniżki w kwietniu
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Regulaminy;
